/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const bookingOnlineSettings = sqliteTable('booking_online_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  enabled: integer('enabled'),
  public_path: text('public_path'),
  default_appointment_status_id: text('default_appointment_status_id'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
